module.exports = __webpack_public_path__ + "img/delete.46c0e06b.svg";